<template>
  <b-input-group class="datepicker">
    <b-form-input
      v-model="innerValue"
      type="text"
      :placeholder="placeholder"
      class="datepicker__input"
      :disabled="disabled"
    />
    <b-input-group-append>
      <b-form-datepicker
        :value="value"
        @input="val => $emit('input', val)"
        button-only
        right
        locale="ru-RU"
        :button-variant="buttonVariant"
        :disabled="disabled"
      />
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: ""
    },
    placeholder: {
      type: String,
      required: false,
      default: "дд.мм.гггг"
    },
    buttonVariant: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    innerValue: {
      get: ({ value }) =>
        value !== null
          ? value
              .split("-")
              .reverse()
              .join(".")
          : value,
      set: function(val) {
        if (val !== null)
          this.$emit(
            "input",
            val
              .split(".")
              .reverse()
              .join("-")
          );
      }
    }
  }
};
</script>

<style>
.datepicker {
}
</style>
